import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  regenerateAudio: null,
  regenerateTitle: 'Choose One',
  regeneratePrompt: '',
  regenerateAudioDetails: false
}

const voiceCloneSlice = createSlice({
  name: 'voiceClone',
  initialState,
  reducers: {
    updateVoiceCloneData: (state, action) => {
      Object.assign(state, action.payload)
    },
    resetVoiceCloneData: () => initialState
  }
})

export const { updateVoiceCloneData, resetVoiceCloneData } =
  voiceCloneSlice.actions

export default voiceCloneSlice.reducer
